import React from 'react';
import { MedSolCombobox, IComboboxProps } from '@ms/medsol-components';

interface ISelectInputProps extends IComboboxProps {}

/** Currently a wrapper around MedSolCombobox. Can be extended with more props as they are needed. */
export function SelectInput({ name, placeholder, options, onChange, value, isMulti = false, ...rest }: ISelectInputProps) {
    return <MedSolCombobox name={name} placeholder={placeholder} options={options} onChange={onChange} value={value} {...rest} />;
}
